import React from "react";
import { Box, Typography, createStyles, withStyles } from "@material-ui/core";
import FrequencyPill from "./FrequencyPill.web";

interface Props {
  name: string;
  priceLabel: string;
  frequencyLabel: string;
  note?: string;
  classes: Record<string, string>;
}

const styles = (theme: any) =>
  createStyles({
    row: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "1rem",
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: 8,
      padding: "0.5rem 1rem",
      marginTop: "0.5rem",
    },
    price: {
      display: "flex",
      alignItems: "center",
      gap: "0.5rem",
      whiteSpace: "nowrap",
    },
  });

const AddonLineItem = ({
  name,
  priceLabel,
  frequencyLabel,
  note,
  classes,
}: Props) => (
  <Box className={classes.row}>
    <Typography variant="body2">
      {name}
      {note ? ` (${note})` : ""}
    </Typography>
    <Box className={classes.price}>
      <Typography variant="body2" color="primary">
        {priceLabel}
      </Typography>
      <FrequencyPill label={frequencyLabel} />
    </Box>
  </Box>
);

export default withStyles(styles)(AddonLineItem);
